/*
 * An object containing filter positions
 */
export class CardFilterPosition {
  /**
   * Footer position
   */
  static readonly FOOTER: string = 'footer';

  /**
   * Header position
   */
  static readonly HEADER: string = 'header';
}
